
    import './styles.scoped.css';
    export default {
  "toggle-button": "awsui_toggle-button_16w0h_1pmxz_181",
  "close-button": "awsui_close-button_16w0h_1pmxz_216"
};
  